module.exports = {
  title: window.g.TITLE ? window.g.TITLE : '一体化管理平台',
  //顶部栏
  fixedHeader: true,
  //侧边栏logo
  sidebarLogo: typeof window.g.SIDEBAR_LOGO === 'boolean' ? window.g.SIDEBAR_LOGO : true,
  //系统编号
  sysAppId: window.g.SYSAPPID ? window.g.SYSAPPID : '23021984-5501-4870-8ba6-1a48a2ef0d17',
  //视频会话地址
  videoUrl: 'https:vroom.kayicloud.com',
  // 本地登录 在页面搭建初期，不请求接口时可用 true ，跳过登录请求，显示本地配置
  isLocal: false,
  //影像上传header参数
  AppId: '91330303307725954N',
  AppKey: "A66FD104767B4226A3C2F05AC80E97C8"
}



// WEBPACK FOOTER //
// ./src/settings.js